import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-227" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-lava/30 border-l-4 border-l-lava bg-petrol p-4 pr-10 text-snow shadow-2xl shadow-black/50" aria-live="polite" data-id="element-228" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-snow focus:outline-none focus-visible:ring-2 focus-visible:ring-energy" aria-label="Dismiss notice" data-id="element-229" data-mp="1sgpfx7ljo9jj">
            <XIcon className="h-4 w-4" data-id="element-230" data-mp="19peperjqdys6" />
          </button>
          <div className="flex gap-3" data-id="element-231" data-mp="19ntuh0ti8dts">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-energy" aria-hidden="true" data-id="element-232" data-mp="1eg4zuj70krtq" />
            <div data-id="element-233" data-mp="zr8p2edkp0pf">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-lava" data-id="element-234" data-mp="zrqua0i7qp9h">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-235" data-mp="14rdamitc8lmi">
                Once your purchase is complete you receive the
                <br data-id="element-236" data-mp="qrc7sxtij44e" />
                <span className="font-bold text-snow" data-id="element-237" data-mp="qswvc3hetmsr">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-238" data-mp="vrgejw4mckhf">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}